<template>

    <v-list-item-group v-model="selected_items" multiple>

        <v-list-item class="verydense" value="inbound">
            <v-list-item-action>
                <v-icon>
                    {{ selected_items.some(a => a === 'inbound') ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                </v-icon>
            </v-list-item-action>

            <v-list-item-content>
                {{ Translate('Inbound') }}
            </v-list-item-content>
        </v-list-item>

        <v-list-item class="verydense" value="outbound">
            <v-list-item-action>
                <v-icon>
                    {{ selected_items.some(a => a === 'outbound') ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                </v-icon>
            </v-list-item-action>

            <v-list-item-content>
                {{ Translate('Outbound') }}
            </v-list-item-content>
        </v-list-item>

    </v-list-item-group>

</template>

<script>
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                selected_items: [],
            }
        },
        props: {
            item: Object,
            value: null,
        },
        created() {
            if (this.value && this.value.values)
                this.selected_items = this.value.values;
        },
        watch: {
            selected_items: function (newv) {
                // When all items are selected, we disable this filter
                if (newv.length == 2 || newv.length < 1)
                    this.$emit('change', {});
                else
                    this.$emit('change', {
                        filterType: "set",
                        values: newv
                    });
            },
            value: {
                handler(newValue) {
                       this.syncFromProps(newValue);
                },
                deep: true,
                immediate: true 
            }
        },
        methods: {
            ...methods,
             syncFromProps(value) {
                if (!value || Object.keys(value).length === 0 || value.cleared == 1) {
                    if (this.selected_items.length > 0)
                    {
                      this.selected_items = [];
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
</style>